import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { RateSchedule } from "../../../../inventory/inventory";

@Component({
  selector: "common-add-to-cart-dates",
  templateUrl: "./add-to-cart-dates.component.html",
  styleUrls: ["./add-to-cart-dates.component.scss"],
})
export class AddToCartDatesComponent implements OnInit {
  @Input() startDate: NgbDate;
  @Input() duration: number = 7;
  @Input() zipcode: string;
  @Input() rpoEnabled: boolean;
  @Input() rpoInterested: boolean;
  @Input() rateSchedules: RateSchedule[];
  @Input() blockWeekends: boolean = true;
  @Input() showZipCode: boolean = true;

  inCheckout: boolean;
  invalidZipCode: boolean;

  @Output() startDateSelected = new EventEmitter<NgbDate>();
  @Output() durationSelected = new EventEmitter<string>();
  @Output() zipcodeChange = new EventEmitter<number>();
  @Output() rpoSelected = new EventEmitter<boolean>();
  showBanner: boolean;

  constructor() {}

  ngOnInit(): void {
    // hack but it works
    this.inCheckout = window.location.pathname.includes("checkout");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.zipcode && changes.zipcode.firstChange == false && changes.zipcode.currentValue === "00000") {
      this.invalidZipCode = true;
      this.zipcode = changes.zipcode.previousValue;
    }
  }

  onStartDateSelected(date: NgbDate) {
    this.startDateSelected.emit(date);
    const selected = new Date(date.year, date.month - 1, date.day);
    const today = new Date();

    // Normalize both dates to midnight (removes time component)
    const normalize = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const selectedNormalized = normalize(selected);
    const todayNormalized = normalize(today);

    // Only continue if today is Friday–Sunday
    const todayDay = todayNormalized.getDay(); // 5 = Fri, 6 = Sat, 0 = Sun
    if (![5, 6, 0].includes(todayDay)) {
      this.showBanner = false;
      return;
    }

    // Get this weekend's Friday and Sunday dates
    const friday = new Date(todayNormalized);
    if (todayDay === 6) friday.setDate(todayNormalized.getDate() - 1);
    // Saturday → back to Friday
    else if (todayDay === 0) friday.setDate(todayNormalized.getDate() - 2); // Sunday → back to Friday

    const sunday = new Date(friday);
    sunday.setDate(friday.getDate() + 2);

    // Check if selected date is in this weekend
    this.showBanner = selectedNormalized >= friday && selectedNormalized <= sunday;
  }

  onDurationSelected(duration: string) {
    this.durationSelected.emit(duration);
  }

  onZipcodeChange(zipcode: number) {
    this.zipcodeChange.emit(zipcode);
    this.invalidZipCode = false;
  }

  rpoChange(event) {
    this.rpoInterested = event;
    this.rpoSelected.emit(event);
  }
}
